// @flow
export function assertNever(impossible: "empty" & "never"): any {}



// WEBPACK FOOTER //
// ./src/common/flow.js